import { memo } from "react";
import { Button, ButtonToolbar, HStack } from "rsuite";
import DynamicIcon from "./DynamicIcon";
import PageTitle from "./PageTitle";
export default memo(function TopHeading({
  pageName,
  buttons=[],
  restComponent=[], 
}) {
  return (
    <HStack justifyContent="space-between" alignItems="baseline" spacing={16}>

      <PageTitle pageName={pageName} />

      <HStack spacing={16}>

        {restComponent?.map(component => component)}

        {buttons?.length ? <ButtonToolbar> 
          {
            buttons.map(({buttonProps: {color, appearance='primary', size="xs", onClick, disabled=false, iconName, iconProps, ...reset}, label}, index) => {
              return <Button
                key={`${label?.toLowerCase().replaceAll("", "_")}_${index}`}
                color={color}
                appearance={appearance}
                size={size}
                disabled={disabled}
                onClick={onClick}
                {...reset}
              >
                <DynamicIcon iconName={iconName} {...iconProps} />{label}
              </Button>
            })
          }

        </ButtonToolbar> : null }

      </HStack>

    </HStack>
  );
})
